export class currentPlan {
    planLodgementId: number;
    planLodgementStage: string;
    planLodgementType: string;
    tenureType: string;
    planType: string;
    planNumber: number;
    planPurpose: string;
    description: string;
    creator: string;
    creatorName: string;
    certifiedBy: string;
    certifiedByName: string;
    assignedTo: string;
    assignedToName: string;
    statusDescription: string;
    surveyorFirm: number;
    surveyorFirmName: string;
    statusDate: number;
    version: number;
    stage: number;
    certifyingSurveyor: string;
    customerReference: string;
    pdfCreationMethod: string;
    attachments?: [];
}

export class DashboardFilters {
    filterBySurveyorFirmName = false;
    filterBySurveyorFirmNameValue = '';
    filterByPlanType = false;
    filterByPlanTypeValue = '';
    filterByPlanNumber = false;
    filterByPlanNumberValue = '';
    filterByVersion = '';
    filterByPurpose = false;
    filterByPurposeValue = '';
    filterByDescription = false;
    filterByDescriptionValue = '';
    filterByPlanLodgementType = false;
    filterByPlanLodgementTypeValue = '';
    filterByPlanCreator = false;
    filterByPlanCreatorValue = '';
    filterByCertifyingSurveyor = false;
    filterByCertifyingSurveyorValue = '';
    filterByCustomerReference = false;
    filterByCustomerReferenceValue = '';
    filterByTenureType = false;
    filterByTenureTypeValue = '';
}
